import { render, staticRenderFns } from "./ComponentFrameSub.vue?vue&type=template&id=f02ecc34&scoped=true"
import script from "./ComponentFrameSub.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFrameSub.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ComponentFrameSub.vue?vue&type=style&index=0&id=f02ecc34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02ecc34",
  null
  
)

export default component.exports